import { salestransaction } from "../json/salesdashboardrecenttranscation";
import { salersretrunsdata } from "../json/salesreturn";
// import { ManageStocksdata } from "../json/managestocks_data";
// import { expiredproduct } from "../json/expiredproductdata";
// import { lowstockdata } from "../json/lowstockdata";
// import { categorylist } from "../json/categorylistdata";
// import { subcateorydata } from "../json/subcategorydata";

const initialState = {
  product_list: [],
  dashboard_recentproduct: [],
  dashboard_expiredproduct: [],
  saleshdashboard_recenttransaction: [],
  brand_list: [],
  unit_data: [],
  variantattributes_data: [],
  warranty_data: [],
  barcode_data: [],
  departmentlist_data: [],
  designation_data: [],
  shiftlist_data: [],
  attendenceemployee_data: [],
  toggle_header: false,
  invoicereport_data: [],
  salesreturns_data: [],
  quotationlist_data: [],
  customerdata: [],
  supplierdata: [],
  managestockdata: [],
  stocktransferdata: [],
  userlist_data: [],
  rolesandpermission_data: [],
  deleteaccount_data: [],
  attendanceadmin_data: [],
  leavesadmin_data: [],
  leavetypes_data: [],
  holiday_data: [],
  expiredproduct_data: [],
  lowstock_data: [],
  categorylist_data: [],
  subcategory_data: [],
  franchise_list: [],
  callhistory_data: [],
  layoutstyledata: localStorage.getItem("layoutStyling"),
};

export default initialState;
